export default "__VITE_ASSET__De$yfHcz__"